import React from "react";
import styles from "./SpookyDecorations.module.css";

// The Addy app's SpookyDecorations, 1:1, so the sidebar matches the page around it.
const LANES = [
  { className: styles.lane1, isReversed: false },
  { className: styles.lane2, isReversed: true },
  { className: styles.lane3, isReversed: false },
  { className: styles.lane4, isReversed: true },
];

const Bat = () => (
  <svg className={styles.bat} viewBox="0 0 64 32" aria-hidden="true" focusable="false">
    <path
      className={styles.wingLeft}
      d="M31 13C26 7 15 4 2 9c4 2 6 5 6 9 3-2.5 6-2.5 8.5 1 2-3.5 5-3.5 7.5 0 2-3 4.5-3.5 7-1.5Z"
    />
    <path
      className={styles.wingRight}
      d="M33 13c5-6 16-9 29-4-4 2-6 5-6 9-3-2.5-6-2.5-8.5 1-2-3.5-5-3.5-7.5 0-2-3-4.5-3.5-7-1.5Z"
    />
    <ellipse cx="32" cy="16.5" rx="3.6" ry="6" />
    <circle cx="32" cy="10" r="3.2" />
    <path d="M29.4 8.6 29 4.2l2.2 3ZM34.6 8.6l.4-4.4-2.2 3Z" />
    <circle className={styles.eyes} cx="30.9" cy="9.8" r="0.6" />
    <circle className={styles.eyes} cx="33.1" cy="9.8" r="0.6" />
  </svg>
);

const Spider = () => (
  <svg className={styles.spider} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <g fill="none" strokeWidth="1.2" strokeLinecap="round">
      <path d="M9 12 4 8l-2 2M9 14l-6-1-1 3M9 16l-5 3v3M10 17l-3 5" />
      <path d="m15 12 5-4 2 2M15 14l6-1 1 3M15 16l5 3v3M14 17l3 5" />
    </g>
    <circle cx="12" cy="8.5" r="2.6" />
    <ellipse cx="12" cy="14.5" rx="3.8" ry="4.4" />
    <circle className={styles.eyes} stroke="none" cx="11" cy="8.2" r="0.55" />
    <circle className={styles.eyes} stroke="none" cx="13" cy="8.2" r="0.55" />
  </svg>
);

const Cobweb = () => (
  <svg className={styles.web} viewBox="0 0 92 92" aria-hidden="true" focusable="false">
    <path d="M92 0 4 0M92 0 20 46M92 0 46 86M92 0 92 88M92 0 70 92" />
    <path d="M70 0q2 10 9 13 4 5 3 13 6 2 10 2" />
    <path d="M48 0q4 18 16 24 6 10 4 24 10 4 24 4" />
    <path d="M26 0q6 26 24 36 9 16 6 36 15 6 36 6" />
  </svg>
);

/** Bats, a cobweb and a spider over the sidebar while Spooky is on. Purely decorative: never takes a click. */
const SpookyDecorations = () => (
  <div className={styles.sky} aria-hidden="true">
    {LANES.map(({ className, isReversed }) => (
      <div key={className} className={`${styles.lane} ${className}${isReversed ? ` ${styles.laneReverse}` : ""}`}>
        <div className={styles.flight}>
          <div className={styles.bob}>
            <Bat />
          </div>
        </div>
      </div>
    ))}
    <Cobweb />
    <div className={styles.spiderAnchor}>
      <div className={styles.spiderDrop}>
        <div className={styles.spiderSway}>
          <span className={styles.thread} />
          <Spider />
        </div>
      </div>
    </div>
  </div>
);

export default SpookyDecorations;
